let $ = require( "jquery" );
import {AddressForm} from '@shopify/theme-addresses';

$(function() {

    let forgotPasswordToggle = $('a[href="#recover"]'),
        recoverForm = $('.account-form-recover'),
        loginForm = $('.account-form-login'),
        forgotPasswordCancel = $('.account-recover-cancel');

    forgotPasswordToggle.on('click', function (e) {
        // e.preventDefault();
        showRecoverPasswordForm();
    });

    forgotPasswordCancel.on('click', function () {
        hideRecoverPasswordForm();
    });

    function showRecoverPasswordForm() {
        recoverForm.toggleClass('hide');
        loginForm.toggleClass('hide');
    }

    function hideRecoverPasswordForm() {
        recoverForm.addClass('hide');
        loginForm.removeClass('hide');
    }

    function checkUrlHash() {
        const hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            showRecoverPasswordForm();
        }
    }

    if(recoverForm.length) {
        checkUrlHash();
        resetPasswordSuccess();
    }

    function resetPasswordSuccess() {
        // check if reset password form was
        // successfully submitted and show success message.

        if ($('.reset-pass-success').length) {
            $('.reset-pass-success').removeClass('hide');
        }
    }


    /**
     * Addresses Page
     */

    let addressFormToggle = $('.toggle-add-new-address'),
        addressesList = $('.addresses-list'),
        addressForm = $('.new-address-form').find('[data-address-form]');

    addressFormToggle.on('click', function () {
        if(addressesList.hasClass('hide')) {
            addressesList.removeClass('hide');
            addressForm.addClass('hide');
        } else {
            addressesList.addClass('hide');
            addressForm.removeClass('hide');
        }
    });


    const selectors = {
        addressContainer: '[data-address]',
        addressFields: '[data-address-fields]',
        addressToggle: '[data-address-toggle]',
        addressForm: '[data-address-form]',
        addressDeleteForm: '[data-address-delete-form]',
    };
    const hideClass = 'hide';

    function initializeAddressForm(container) {
        const addressFields = container.querySelector(selectors.addressFields);
        const addressForm = container.querySelector(selectors.addressForm);
        const deleteForm = container.querySelector(selectors.addressDeleteForm);

        container.querySelectorAll(selectors.addressToggle).forEach((button) => {
            button.addEventListener('click', () => {
                addressesList.removeClass('hide');
                addressForm.classList.toggle(hideClass);
            });
        });

        AddressForm(addressFields, 'en');

        let proviceSelect = $(addressForm).find('select[name="address[province]"]');

        if(proviceSelect.data('default')) {

            let optionsInterval = setInterval(function () {
                if(proviceSelect.find('option').length) {
                    clearInterval(optionsInterval);

                    $(proviceSelect).find('option').each(function () {
                        if($(this).text() === proviceSelect.data('default')) {
                            $(this).attr('selected', true);
                            $(this).parent()[0].dispatchEvent(new Event('change'));
                        }
                    });
                }
            }, 500);

        }

        if (deleteForm) {
            deleteForm.addEventListener('submit', (event) => {
                const confirmMessage = deleteForm.getAttribute('data-confirm-message');

                if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                    event.preventDefault();
                }
            });
        }
    }

    const addressForms = document.querySelectorAll(selectors.addressContainer);

    if (addressForms.length) {
        addressForms.forEach((addressContainer) => {
            initializeAddressForm(addressContainer);
        });
    }


});
